export enum TensionAccessories {
    ProductGroup = 'tension_accessories.product_group',
}
